import axios from "axios";
import cookieHelper from "../helpers/cookieHelper";
import config from "~/config";

const axiosInstance = axios.create({
  baseURL: config.BNS_API_ENDPOINT,
});

axiosInstance.interceptors.request.use(
  (axiosConfig) => {
    const token = cookieHelper.getTokenFromCookie("StarJwtTokenCookieName");

    if (token && token !== null) {
      axiosConfig.headers.Authorization = `Bearer ${token}`;
    }

    if (axiosConfig.recaptchaAction) {
      return window.grecaptcha
        .execute(config.RECAPTCHA_SITE_KEY, {
          action: axiosConfig.recaptchaAction,
        })
        .then((token) => {
          axiosConfig.headers["RecaptchaToken"] = token;
          return axiosConfig;
        });
    } else {
      return axiosConfig;
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        cookieHelper.removeCookie("StarJwtTokenCookieName");
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
